<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-smeasy"></div>

  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
      <div class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
        <div>
          <div class="mx-auto flex items-center justify-center">
            <div>
              <img width="200" [src]="clientImageUrl" />
            </div>
            <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full  bg-green-100">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
            </div>
            <div>
              <img width="200" src="assets/smeasy_logo.png" />
            </div>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 *ngIf="clientDisplayName" class="text-lg leading-6 font-medium text-gray-900" id="modal-title"><span class="font-bold">{{clientDisplayName}}</span> wants to connect to your SMEasy account</h3>
            <div *ngIf="state===LOGIN" class="mt-2">
              <p class="text-sm text-gray-500 mb-10">In order to allow <span class="font-bold">{{clientDisplayName}}</span> to access your SMEasy account you must first login below.</p>
            </div>
            <div *ngIf="state===AUTH" class="mt-2">
              <p class="text-sm text-gray-500 mb-3">You've successfully logged in. </p>
              <p class="text-sm text-gray-500 mb-3"><span class="font-bold">{{clientDisplayName}}</span> will only be able to read data from your account. They will not be able to make changes to your data.</p>
              <p class="text-sm text-gray-500 mb-10">To allow <span class="font-bold">{{clientDisplayName}}</span> to access your SMEasy account please click the 'Allow' button.</p>
            </div>

            <div *ngIf="state===LOGIN" class="space-y-6 sm:space-y-5">
              <div *ngIf="invalidLogin" class="rounded-md bg-yellow-50 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm font-medium text-yellow-800">{{invalidLoginText}}</p>
                  </div>
                </div>
              </div>

              <form [formGroup]="form" (ngSubmit)="login(model)">
                <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
              </form>
            </div>

            <div *ngIf="state===PROCESSING" class="rounded-md bg-blue-50 p-4 my-5 border border-blue-200">
              <div class="flex">
                <div class="flex-shrink-0">
                  <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                  <p class="text-sm text-blue-700">{{processingText}}</p>
                </div>
              </div>
            </div>

            <div *ngIf="state===ERROR" class="rounded-md bg-red-50 p-4 my-5 border border-red-200">
              <div class="flex">
                <div class="flex-shrink-0">
                  <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-red-800 text-left">We experienced a problem!</h3>
                  <div class="mt-2 text-sm text-red-700">
                    <p [innerHtml]="errorText" class="text-left"></p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button *ngIf="state===LOGIN" (click)="login(model)" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-smeasy text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">Login</button>
          <button *ngIf="state===AUTH" (click)="onAllow()" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-smeasy text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">Allow</button>
          <button *ngIf="state===AUTH" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm">Decline</button>
        </div>
      </div>
    </div>
  </div>
</div>
